module.exports = __webpack_public_path__ + "static/media/routesfallback.4ccc895e.svg";